
export const formatRut = (rut) =>
  rut.replace(/^0+/g, "").replace(/[^0-9Kk]/g, "");
